import type { SearchScenarioId } from "owa-search-store";
import { getScenarioStore } from "owa-search-store";

export default function isSearchBoxEmpty(scenarioId: SearchScenarioId): boolean {
    const store = getScenarioStore(scenarioId);
    
    return store.searchText.trim().length === 0 && store.suggestionPillIds.length === 0;
}
